import React from "react";

function MealList({ meals, onDelete, onEdit, onClearAll }) {
    if (!meals || meals.length === 0) {
        return <p>No Meals tracked yet.</p>;
    }

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h2>Your Meals</h2>
                <button className="btn-delete" onClick={onClearAll}>Clear All</button>
            </div>
            <ul className="meal-list">
                {meals.map((meal) => (
                    <li key={meal.id} className="meal-item">
                        <div className="meal-info">
                            <strong>{meal.name}</strong> - {meal.calories || 0} kcal
                            <div className="meal-macros">
                                Carbs: {meal.carbs || 0}g | Protein: {meal.protein || 0}g | Fats: {meal.fats || 0}g | Fiber: {meal.fiber || 0}g
                            </div>
                        </div>
                        <div className="btn-group">
                            <button className="btn-edit" onClick={() => onEdit(meal)}>Update</button>
                            <button className="btn-delete" onClick={() => onDelete(meal.id)}>Delete</button>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default MealList;